module.exports = __webpack_public_path__ + "media/icons/icon_freee-58bfd325.png";